exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marketing-photo img[data-v-00e45268]{display:block;margin-left:auto;margin-right:auto;width:700px}.col-sm-2-4[data-v-00e45268]{-ms-flex:0 0 18%;flex:0 0 18%;max-width:18%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00e45268","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Marketing.vue
// module id = 176
// module chunks = 0